var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voc-textarea"},[_c('el-input',_vm._b({ref:"voc-textarea",attrs:{"value":_vm.content,"type":"textarea","readonly":_vm.readonly,"disabled":_vm.disabled},on:{"input":_vm.onValueInput}},'el-input',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }